import { render, staticRenderFns } from "./SolutionWsfinderPage.vue?vue&type=template&id=0d323db0&scoped=true"
import script from "./SolutionWsfinderPage.vue?vue&type=script&lang=js"
export * from "./SolutionWsfinderPage.vue?vue&type=script&lang=js"
import style0 from "./SolutionWsfinderPage.vue?vue&type=style&index=0&id=0d323db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d323db0",
  null
  
)

export default component.exports